import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { CUR_DEFICIT_SCOOTERS_LEGEND } from '../../../constants/legends';

const CurDeficitLegendComponent = () => (
    <LegendRenderer config={CUR_DEFICIT_SCOOTERS_LEGEND} />
);

export const CurDeficitLegend = withDisplayedLayersCheck(CurDeficitLegendComponent, t`Текущий дефицит самокатов`);
